import { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";
import { subscribeNewsletter } from "../lib/api";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await subscribeNewsletter(email.trim());
      setDone(true);
      setEmail("");
      toast.success("You're in the circle!", {
        description: "Check your inbox — 15% off your first Featherbomb is on the way.",
      });
    } catch (err) {
      toast.error("Hmm, that didn't work", { description: "Please enter a valid email and try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="relative overflow-hidden bg-[#184786] px-5 py-20 sm:py-28" data-testid="newsletter-section">
      <div className="pointer-events-none absolute -right-20 -top-20 h-80 w-80 rounded-full bg-[#EE4026]/30 blur-3xl" />
      <div className="relative mx-auto max-w-4xl text-center">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-white/70">The Bomb Circle</p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="font-display mt-4 text-4xl uppercase leading-[0.95] text-white sm:text-6xl"
        >
          Get 15% off <span className="text-[#EE4026]">your first kick</span>
        </motion.h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/70 sm:text-lg">
          Drop your email for launch drops, Flockboard prizes, and a discount code that lands instantly.
        </p>

        <form onSubmit={submit} className="mx-auto mt-9 flex max-w-lg flex-col gap-3 sm:flex-row">
          <input
            data-testid="newsletter-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            className="w-full rounded-full border border-white/20 bg-white/10 px-6 py-4 text-white placeholder:text-white/50 outline-none transition focus:border-white/60"
          />
          <button
            data-testid="newsletter-submit-button"
            type="submit"
            disabled={loading}
            className="btn-primary flex items-center justify-center gap-2 rounded-full px-7 py-4 text-sm font-bold uppercase tracking-wide disabled:opacity-70"
          >
            {loading ? <Loader2 className="animate-spin" size={18} /> : done ? "Subscribed" : "Join"}
            {!loading && <ArrowRight size={18} />}
          </button>
        </form>
        <p className="mt-4 font-mono text-[11px] uppercase tracking-widest text-white/40">
          No spam. Just good bombs.
        </p>
      </div>
    </section>
  );
};
